import React from "react";

const Footer = props => (
  <div className="footer">
    <div className="footer-section">
      &copy; Sanako Oy
      <br />
      <br />
      <a target="_blank" href="http://www.sanako.com/help/pronounce-live-faq/">
        Pronounce Live FAQ
      </a>
      <br />
      <a href="/about">About</a>
      <br />
      <a href="/terms">Terms of Use</a>
      <br />
      <a href="/privacy">Privacy</a>
    </div>
    <div className="footer-section">
      Pronounce Live:
      <br />
      <br />
      <a href="/register">Create an account</a>
      <br />
      <a href="/password/email">Reset your password</a>
    </div>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js